module.exports = __webpack_public_path__ + "img/AEI.5e458ddf.png";